import { withStateHandlers } from 'recompose';

import { CopyToClipboard as CPY } from './CopyToClipboard';

export const CopyToClipboard = withStateHandlers(
  {
    isCopied: false,
  },
  {
    onCopy: () => () => ({
      isCopied: true,
    }),
    onOver: () => () => ({
      isCopied: false,
    }),
  },
)(CPY);
